import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import {
  activeTabIndexSelector,
  getDataExplorerPathnameSelector,
  getLearnPathnameSelector,
} from '../../reducers/EditorReducer/EditorSelector';
import { toggleSimulationFilterThunk } from '../../actions/Simulation/SimulationFiltersActions';
import { activeFiltersSelector } from '../../reducers/SimulationReducer/FiltersReducer/FiltersSelector';
import {
  BaseFiltersStoreElement,
  FiltersStoreElement,
  SimulationFilterWithRouter,
} from '../../reducers/SimulationReducer/FiltersReducer/FiltersReducer.types';
import { SIMULATE } from '../../shared/constants';
import {
  editorRouterFiltersConfig,
  getFullPathname,
  getIsDataExplorerPathname,
  getIsLearnPathname,
  getIsTutorialPathname,
  SIMULATION_FILTERS_WITH_ROUTER,
} from '../../reducers/SimulationReducer/FiltersReducer/FiltersConfig';
import { useAppDispatch } from '../../shared/services/store/useAppDispatch';

export const EditorRouterFiltersManager = () => {
  const dispatch = useAppDispatch();
  const activeTabIndex = useSelector(activeTabIndexSelector) as number;
  const history = useHistory();
  const activeTabFilters = (useSelector(activeFiltersSelector) as FiltersStoreElement)?.toJS() as unknown as
    | BaseFiltersStoreElement
    | undefined;

  const dataExplorerPathname = useSelector(getDataExplorerPathnameSelector) as string;
  const learnPathname = useSelector(getLearnPathnameSelector) as string;

  const fullPathname = getFullPathname(history.location);
  const pathname = history.location.pathname;

  const initRef = useRef(false);
  useEffect(() => {
    if (activeTabFilters) {
      if (getIsLearnPathname(pathname) && !activeTabFilters.learn) {
        dispatch(toggleSimulationFilterThunk(SIMULATION_FILTERS_WITH_ROUTER.learn, activeTabIndex, history));
      } else if (getIsDataExplorerPathname(pathname) && !activeTabFilters.dataExplorer) {
        dispatch(toggleSimulationFilterThunk(SIMULATION_FILTERS_WITH_ROUTER.dataExplorer, activeTabIndex, history));
      } else if (getIsTutorialPathname(pathname) && !activeTabFilters.tutorial) {
        dispatch(toggleSimulationFilterThunk(SIMULATION_FILTERS_WITH_ROUTER.tutorial, activeTabIndex, history));
      } else if (pathname === SIMULATE) {
        if (activeTabFilters.dataExplorer) {
          history.replace(dataExplorerPathname);
        } else if (activeTabFilters.learn) {
          history.replace(learnPathname);
        }
      }
      initRef.current = true;
    }
  }, [fullPathname, activeTabIndex, history, pathname, dataExplorerPathname, learnPathname]);

  return null;
};

export const useEditorRouterFilter = (domain: SimulationFilterWithRouter) => {
  const componentConfig = editorRouterFiltersConfig[domain];
  const dispatch = useAppDispatch();
  const history = useHistory();
  const fullPathname = getFullPathname(history.location);

  useEffect(() => {
    if (componentConfig.isPathnameCorrect(fullPathname)) {
      dispatch(componentConfig.setPathnameAction(fullPathname));
    }
  }, [fullPathname, componentConfig]);
};
